import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import ModuleAccessDenied from "../components/ModuleAccessDenied";
import { useModuleAccess } from "../context/ModuleAccess/ModuleAccessContext";


const Route = ({
	component: Component,
	isPrivate = false,
	userFeature,
	...rest
}) => {
	const { isAuth, loading } = useContext(AuthContext);
	const access = useModuleAccess();

	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth && isPrivate) {
		return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
	}

	if (isAuth && !isPrivate) {
		return <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
	}

	if (isAuth && isPrivate && userFeature) {
    const featureByPermission = {
      allowKanban: "kanban",
      allowCrm: "crm",
      ai: "ai",
    };
    const feature = featureByPermission[userFeature];
    if (access.loading) return <RouterRoute {...rest} render={() => <BackdropLoading />} />;
    if (access.features[feature]?.allowed !== true) {
      return <RouterRoute {...rest} render={() => <ModuleAccessDenied
        reason={access.features[feature]?.reason} onRetry={access.refresh}
      />} />;
    }
  }

	return <RouterRoute {...rest} component={Component} />;
};

export default Route;
